<template>
	<div class="qualityenterprise" style="height: 100vh;" v-title :data-title="title">
		<leftnav class="fl" mkcode="B" itemcode="B-CYSJK"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<watermark :isShowMark='isshowWaterMark' :refreshNum="refreshNum_watermark">
				<div class="index_left_centerpage">
					<div class="whitebox right_topbox" style="padding-bottom: 0;">
						<div class="right_boxtitle map_title_tab ">
							<span class="title" :class="{ 'current': pageType == list.value }"
								v-for="(list, i) in pageTypeOption" :key="i" @click="choosePageType(list.value)">{{
									list.label }}</span>
							<span class="fr showechart-c6" @click="showechart = !showechart"
								v-show="pageType == 1 && statisticalValue != 0">{{ showechart ? '隐藏' : '查看' }}图表</span>
						</div>
						<!-- 产业概念细分筛选 -->
						<div>
							<notionScreen :type="2" :notionNumberList="notionNumList" :refreshNum="notionNumRefresh"
								:token="userdata.token" @chooseNotion="chooseNotion" :isShowNotionScreen="true"
								:isClearNotion="isClearNotion" :showLevelNum="3" :isShowOneLevelTotal='false'
								:isShowManufacturing="false" :showNotionCodeList="notioncodeList_data"
								:linkNotionCode="link_notionCode">
							</notionScreen>
							<div v-show="pageType == 0">
								<dl class="opport-screen bdbe">
									<dt class="fl">数据类型</dt>
									<dd class="fl">
										<!-- <span @click="marketValue = 0"
											:class="marketValue == 0 ? 'a-screen current' : 'a-screen'">全部</span> -->
										<span :key="index" v-for="(item, index) in allDataOptions"
											@click="allDataOptionsClick(1, item)"
											:class="allDataValue1 == item.value ? 'a-screen current' : 'a-screen'">{{
												item.label }}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe">
									<dt class="fl">{{ allDataTitle }}</dt>
									<dd class="fl">
										<span :key="index" v-for="(item, index) in allDataOptions2"
											@click="allDataOptionsClick(2, item);"
											:class="allDataValue2 == item.value ? 'a-screen current' : 'a-screen'">{{
												item.label }}</span>
									</dd>
								</dl>
							</div>
							<dl class="opport-screen bdbe" v-show="pageType == 1">
								<dt class="fl">统计数据</dt>
								<dd class="fl">
									<span @click="statisticalValue = 0"
										:class="statisticalValue == 0 ? 'a-screen current' : 'a-screen'">全部</span>
									<span :key="index" v-for="(item, index) in statisticalDataOptions"
										@click="statisticalValue = item.value;"
										:class="statisticalValue == item.value ? 'a-screen current' : 'a-screen'">{{
											item.label }}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="pageType == 5">
								<dt class="fl">数据类型</dt>
								<dd class="fl">
									<!-- <span @click="dataType = 0"
										:class="statisticalValue == 0 ? 'a-screen current' : 'a-screen'">全部</span> -->
									<span :key="index" v-for="(item, index) in dataTypeList"
										@click="industryClilk(item);"
										:class="dataType == item.value ? 'a-screen current' : 'a-screen'">{{ item.label
										}}</span>
								</dd>
							</dl>
						</div>
						<!-- <notionScreen v-show="pageType == 2 || pageType == 3|| pageType == 4" :type="2" :notionNumberList="notionNumList" :refreshNum="notionNumRefresh"
						:token="userdata.token" @chooseNotion="chooseNotion" :isShowNotionScreen="true"
						:isClearNotion="isClearNotion" :showLevelNum="5" :isShowOneLevelTotal='false' :isShowManufacturing="true">
					</notionScreen> -->

					</div>
					<div class="whitebox pb-4 pt-3">
						<!-- 柱状图 概念企业数量 -->
						<div class="fixedEchartBar1 w95mg oh por pt-2" v-show="showechart">
							<div class="fl" style="width: 48%;margin-right: 40px;">
								<div class="land-ecahrt-title">
									<h5 :class="provinceInvestType == 1 ? 'current title fl' : 'title fl'"
										@click="PiechartFun('fixedEchartPie', 1)">{{ chartText }}省份分布 </h5>
									<h5 :class="provinceInvestType == 2 ? 'current title fl' : 'title fl'"
										@click="PiechartFun('fixedEchartPie', 2)">{{ chartText }}城市分布 </h5>
									<el-select v-model="years" clearable @change="getIndustryLibrayChartData"
										placeholder="请选择年份" size="small">
										<el-option v-for="item in yearsOptions" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
								<div id="fixedEchartPie" class="echart-line-box"
									:style="'width:' + echartWidth2 + 'px;'">
								</div>
							</div>
							<div class="fl" style="width: 48%;">
								<div class="land-ecahrt-title">
									<h5 :class="rankType == item.value ? 'current title fl' : 'title fl'" :key="index"
										v-for="(item, index) in rankTypeList" @click="rankTrunData(item)">
										历年{{ item.label }} </h5>
								</div>
								<!-- <div class="land-ecahrt-title tac"><b>历年{{chartText}}数量</b></div> -->
								<div id="fixedEchartBar" class="echart-line-box"
									:style="'width:' + echartWidth2 + 'px;'">
								</div>
							</div>
							<span class="closebtn" @click="showechart = false"></span>
						</div>
						<div v-show="pageType == 0" class="widthPC-95 margin-x-auto" style="min-height: 420px;">
							<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
								<tr>
									<th style="width: 40%;" class="text-left pl-5">数据名称</th>
									<th>单位</th>
									<th>起止时间</th>
									<th>操作</th>
								</tr>
								<tr v-for="(item, index) in alltableData" :key="index">
									<td class="text-left" @click="clickToView(item)"><span
											class="curp"><i v-if="allDataValue1 == 1 && allDataValue2 == 3">历年</i>{{
												item.title }}</span></td>
									<td>{{ item.unit || '-' }}</td>
									<td>{{ item.startTime }}<span>-</span>{{ item.endTime }}</td>
									<td @click="clickToView(item)"><span class="curp">查看</span></td>
								</tr>
							</table>
						</div>
						<div class="scrollable-table-wrapper" v-show="pageType == 1">
							<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table growth_table">
								<tr>
									<th></th>
									<th><span class="inline-block width50PC">2024年</span> <span
											class="inline-block width50PC">增长率</span></th>
									<th><span class="inline-block width50PC">2023年</span> <span
											class="inline-block width50PC">增长率</span></th>
									<th><span class="inline-block width50PC">2022年</span> <span
											class="inline-block width50PC">增长率</span></th>
									<th><span class="inline-block width50PC">2021年</span> <span
											class="inline-block width50PC">增长率</span></th>
									<th><span class="inline-block width50PC">2020年</span> <span
											class="inline-block width50PC">增长率</span></th>
									<th><span class="inline-block width50PC">2019年</span> <span
											class="inline-block width50PC">增长率</span></th>
									<th><span class="inline-block width50PC">2018年</span> <span
											class="inline-block width50PC">增长率</span></th>
								</tr>
								<tr v-show="statisticalValue == 0 || statisticalValue == 1">
									<td class="font-weight text-left py-col-15 border-top fixd-title">上市公司</td>
									<td colspan="7"></td>
								</tr>
								<tr v-for="(list, i) in enterpristlist" :key="i + 'ss'" v-if="list.id < 5"
									v-show="statisticalValue == 0 || statisticalValue == 1">
									<td class="text-dent text-left">{{ list.title == '上市公司数' ? '上市公司总数' : list.title
										}}<span class="font-size14" v-if="list.title != '上市公司数'">({{ list.unit ?
											list.unit :
											'' }})</span></td>
									<td v-for="(item, dataI) in list.data" :key="'s' + dataI"><span
											class="inline-block width50PC">{{ toFixedFn(item.value) == 0 ? "-" :
												toFixedFn(item.value) }}</span><span class="inline-block width50PC">{{
												item.growth == 0 ? '-' : item.growth + '%' }}</span></td>
									<td v-for="(item, dataI) in 7" :key="dataI + '_s'" v-if="list.data.length == 0">
										<span class="inline-block width50PC">-</span><span
											class="inline-block width50PC">-</span>
									</td>
								</tr>
								<tr v-show="statisticalValue == 0 || statisticalValue == 2">
									<td class="font-weight text-left py-col-15 border-top">新增投资项目</td>
									<td colspan="7"></td>
								</tr>
								<tr v-for="(list, i) in enterpristlist" :key="i + 'tz'"
									v-show="statisticalValue == 0 || statisticalValue == 2"
									v-if="list.title == '投资项目数量' || list.title == '投资项目金额'">
									<td class="text-dent text-left">{{ list.title }}<span class="font-size14"
											v-if="list.title == '投资项目金额'">({{ list.unit ? list.unit : '' }})</span></td>
									<td v-for="(item, dataI) in list.data" :key="dataI + 'itz'"><span
											class="inline-block width50PC">{{ toFixedFn(item.value) == 0 ? "-" :
												toFixedFn(item.value) }}</span><span class="inline-block width50PC">{{
												item.growth == 0 ? '-' : item.growth + '%' }}</span></td>
									<td v-for="(item, dataI) in 7" :key="dataI + '_t'" v-if="list.data.length == 0">
										<span class="inline-block width50PC">-</span><span
											class="inline-block width50PC">-</span>
									</td>
								</tr>
								<tr v-show="statisticalValue == 0 || statisticalValue == 3">
									<td class="font-weight text-left py-col-15 border-top">新增融资项目</td>
									<td colspan="7"></td>
								</tr>
								<tr v-for="(list, i) in enterpristlist" :key="i + 'rz'"
									v-show="statisticalValue == 0 || statisticalValue == 3"
									v-if="list.title == '融资项目数量' || list.title == '融资项目金额'">
									<td class="text-dent text-left">{{ list.title }} <span class="font-size14"
											v-if="list.title == '融资项目金额'">({{ list.unit ? list.unit : '' }})</span></td>
									<td v-for="(item, dataI) in list.data" :key="'rz' + dataI"><span
											class="inline-block width50PC">{{ toFixedFn(item.value) == 0 ? "-" :
												toFixedFn(item.value) }}</span><span class="inline-block width50PC">{{
												item.growth == 0 ? '-' : item.growth + '%' }}</span></td>
									<td v-for="(item, dataI) in 7" :key="dataI + '_r'" v-if="list.data.length == 0">
										<span class="inline-block width50PC">-</span><span
											class="inline-block width50PC">-</span>
									</td>
								</tr>
								<tr v-show="statisticalValue == 0 || statisticalValue == 4">
									<td class="font-weight text-left py-col-15 border-top">新增拿地项目</td>
									<td colspan="7"></td>
								</tr>
								<tr v-for="(list, i) in enterpristlist" :key="i + 'nd'"
									v-show="statisticalValue == 0 || statisticalValue == 4"
									v-if="list.title == '拿地项目数量' || list.title == '拿地项目金额' || list.title == '拿地项目面积'">
									<td class="text-dent text-left">{{ list.title }}<span class="font-size14"
											v-if="list.title == '拿地项目金额' || list.title == '拿地项目面积'">({{ list.unit ?
												list.unit : '' }})</span>
									</td>
									<td v-for="(item, dataI) in list.data" :key="'nd' + dataI"><span
											class="inline-block width50PC">{{ toFixedFn(item.value) == 0 ? "-" :
												toFixedFn(item.value) }}</span><span class="inline-block width50PC">{{
												item.growth == 0 ? '-' : item.growth + '%' }}</span></td>
									<td v-for="(item, dataI) in 7" :key="dataI + '_n'" v-if="list.data.length == 0">
										<span class="inline-block width50PC">-</span><span
											class="inline-block width50PC">-</span>
									</td>
								</tr>
								<!-- 创投项目 -->
								<tr v-show="statisticalValue == 0 || statisticalValue == 5">
									<td class="font-weight text-left py-col-15 border-top">新增创投项目</td>
									<td colspan="7"></td>
								</tr>
								<tr v-for="(list, i) in enterpristlist" :key="i + 'nd'"
									v-show="statisticalValue == 0 || statisticalValue == 5"
									v-if="list.title == '创投项目数量' || list.title == '创投项目金额'">
									<td class="text-dent text-left">{{ list.title }}<span class="font-size14"
											v-if="list.title == '创投项目金额'">({{ list.unit ? list.unit : '' }})</span>
									</td>
									<td v-for="(item, dataI) in list.data" :key="'nd' + dataI"><span
											class="inline-block width50PC">{{ toFixedFn(item.value) == 0 ? "-" :
												toFixedFn(item.value) }}</span><span class="inline-block width50PC">{{
												item.growth == 0 ? '-' : item.growth + '%' }}</span></td>
									<td v-for="(item, dataI) in 7" :key="dataI + '_n'" v-if="list.data.length == 0">
										<span class="inline-block width50PC">-</span><span
											class="inline-block width50PC">-</span>
									</td>
								</tr>
								<!-- <tr v-show="statisticalValue == 0 || statisticalValue == 5">
								<td class="font-weight text-left py-col-15 border-top" v-show="productList.length > 0">当年产品产量</td>
								<td colspan="7" v-show="productList.length > 0"></td>
							</tr>
							<tr v-for="(list, i) in productList" :key="i + 'pro'" v-show="statisticalValue == 0 || statisticalValue == 5">
								<td class="text-dent text-left">{{ list.title }} <span
										class="font-size14">({{ list.unit ? list.unit : '' }})</span></td>
								<td v-for="(item, dataI) in list.data" :key="'pro' + dataI"><span
										class="inline-block width50PC">{{ toFixedFn(item.value) == 0 ? "-" : toFixedFn(item.value) }}</span><span
										class="inline-block width50PC">{{ item.growth == 0 ? '-' : item.growth + '%' }}</span></td>
								<td v-for="(item, dataI) in 7" :key="dataI + '_pro'" v-if="list.data.length == 0"><span
										class="inline-block width50PC">-</span><span class="inline-block width50PC">-</span>
								</td>
							</tr> -->
							</table>
						</div>
						<div v-show="pageType == 2 || pageType == 3 || pageType == 4 || pageType == 5" style="min-height: 580px;">
							<div class="market-box w95mg oh" v-show="pageType == 2">
								<div v-for="(list, i) in marketList" :key="i" class="fl market-list mb-2">
									<h4 class="mt-1 market-title"
										@click="routerblank('/marketDetail?type=1&id=' + list.id)">{{ list.title }}</h4>
									<div style="width: 90%;height: 290px;margin: 0 auto;" :id="'bar_charts_' + i"></div>
								</div>
							</div>
							<div class="market-box w95mg oh" v-show="pageType == 3">
								<div v-for="(list, i) in marketList" :key="i" class="fl market-list mb-2">
									<h4 class="mt-1 market-title"
										@click="routerblank('/marketDetail?type=2&id=' + list.id)">{{ list.title }}</h4>
									<div style="width: 90%;height: 290px;margin: 0 auto;" :id="'pie_charts_' + i"></div>
								</div>
							</div>
							<div class="market-box w95mg oh" v-show="pageType == 4">
								<div v-for="(list, i) in productList" :key="i" class="fl market-list mb-2">
									<h4 class="mt-1 market-title tac"
									@click="routerblank('/bureauStatisticsDetail?type=8' + '&code=' + list.code)">
									历年{{ list.title }}</h4>
									<div style="width: 90%;height: 290px;margin: 0 auto;" :id="'cp_charts_' + i"></div>
								</div>
							</div>
							<div class="market-box w95mg oh" v-show="pageType == 5">
								<div v-for="(list, i) in industyrDataList" :key="i" class="fl market-list mb-2">
									<h4 class="mt-1 market-title tac"
										@click="routerblank('/bureauStatisticsDetail?type=' + dataType + '&code=' + list.code)">
										{{ list.title }}</h4>
									<div style="width: 90%;height: 290px;margin: 0 auto;" :id="'indutry_charts_' + i">
									</div>
								</div>
							</div>
							<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
								<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
									v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
							</div>
						</div>



					</div>
				</div>
			</watermark>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { sortKey } from '@/utils/index.js'
export default {
	name: 'industryLibrary',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse']),

	},
	data() {
		return {
			curWebsite: this.$api.getWebsiteType(),
			title: "产业数据库",
			userdata: {},
			page: 1,  //显示的是哪一页
			haspage: true,//是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10,  //最大页数
			enterpristlist: [],
			kwtextsearchtext: '',
			kwtextsearch: '',
			notionlist: [],
			notionlist2: [],
			chooseNotion0: 'A',
			chooseNotion1: "",
			chooseNotion2: '',
			testList: [],
			industryType: 1,
			productList: [],
			notionNumList: [],
			notionNumRefresh: 1,
			isClearNotion: false,
			notionCode: 'A',
			notionstep: '',
			statisticalDataOptions: [{ label: '上市公司', value: 1 }, { label: '投资项目', value: 2 }, { label: "融资项目", value: 3 }, { label: "拿地项目", value: 4 }, { label: "创投项目", value: 5 }],
			pageType: 0,
			pageTypeOption: [{ label: '产业数据库', value: 1 }, { label: '产业市场规模', value: 2 }, { label: '产业竞争格局', value: 3 }, { label: "产品产量", value: 4 },
			{ label: "行业统计数据", value: 5 }, { label: "全部", value: 0 }
			],//
			marktetType: 1,
			marketList: [],
			showechart: false,
			chartText: '上市公司',
			echartWidth2: document.body.offsetWidth * 0.8728 * 0.95 * 0.48,
			yearsOptions: [
				{ value: '2024', label: '2024' },
				{ value: '2023', label: '2023' },
				{ value: '2022', label: '2022' },
				{ value: '2021', label: '2021' },
				{ value: '2020', label: '2020' },
				{ value: '2019', label: '2019' },
				{ value: '2018', label: '2018' },
			],
			rankType: 1,
			rankTypeList: [],
			ssgsRankTypeList: [{ label: '上市公司数量', value: 1, text: '上市公司数' }, { label: '上市公司营业收入', value: 2, text: '总营业收入' }, { label: '上市公司净收入', value: 3, text: '总净利润' }, { label: '上市公司研发费用', value: 4, text: '总研发费用' }],
			tzxmRankTypeList: [{ label: '投资项目数量', value: 1, text: '投资项目数量' }, { label: '投资项目金额', value: 2, text: '投资项目金额' }],
			rzxmRankTypeList: [{ label: '融资项目数量', value: 1, text: '融资项目数量' }, { label: '融资项目金额', value: 2, text: '融资项目金额' }],
			ndxmRankTypeList: [{ label: '拿地项目数量', value: 1, text: '拿地项目数量' }, { label: '拿地项目金额', value: 2, text: '拿地项目金额' }, { label: '拿地项目面积', value: 3, text: '拿地项目面积' }],
			ctxmRankTypeList: [{ label: '创投项目数量', value: 1, text: '创投项目数量' }, { label: '创投项目金额', value: 2, text: '创投项目金额' }],
			years: '',
			provinceInvestType: 1,
			provinceChartData: [],
			cityChartData: [],
			barChartData: [],
			statisticalValue: 0,
			colors: ['rgb(84,128,191)', '#ffbb1c', '#47a59d', "#f60", "#fde906", "#816fd9", "#aaaaff", "#ffc6df", "#f87f8f"],
			isshowWaterMark: false, //是否显示水印
			refreshNum_watermark: 1,
			notioncodeList_data: {},
			link_notionCode: '',
			dataTypeList: [
				{ label: '国家-年度', value: 1 },
				// { label: '省份-年度', value: 2 },
				{ label: '国家-月度', value: 3 },
				{ label: '国家-季度', value: 4 },
				// { label: '省份-月度', value: 5 },
				// { label: '城市-月度', value: 6 },
			],
			dataType: 1,
			industyrDataList: [],
			allDataOptions: [
				{
					label: '市场数据', value: 1,
					children: [{ label: '市场规模', value: 1 }, { label: '竞争格局', value: 2 }, { label: '产品产量', value: 3 }, { label: "年度价格变化", value: 4 },
					{ label: "月度价格变化", value: 5 }]
				},
				{
					label: '经营数据', value: 2,
					children: [{ label: '年度经营数据', value: 1 }, { label: '月度经营数据', value: 3 }, { label: '季度生产数据', value: 4 }, { label: "研发创新数据", value: 7 },],
				},
				{
					label: '投融资数据', value: 3,
					children: [{ label: '上市公司数量', value: 1 }, { label: '新增投资项目', value: 2 }, { label: '新增融资项目', value: 3 }, { label: "新增拿地项目", value: 4 },
					{ label: "新增创投项目", value: 5 }]
				},
			],
			allDataValue1: 1,
			allDataValue2: 1,
			allDataOptions2: [],
			allDataTitle: '市场数据',//整合后的二级标题
			resultType: 0,//接口返回值类型，全部的时候要返回表格，其他返回图表数据
			alltableData: [],
			routerUrl: '',
			isShowFreeUserTips:false,
			mychart: null,
		}
	},
	watch: {
		statisticalValue: {
			//immediate: true, // 设置为true，在监听开始时立即触发
			handler(newValue, oldValue) {
				// console.log(newValue,oldValue);
				if (newValue == 0) {
					this.showechart = false;
				} else {
					this.showechart = true;
					if (newValue == 1) {
						this.chartText = '上市公司';
						this.rankTypeList = this.ssgsRankTypeList;
					} else if (newValue == 2) {
						this.chartText = '投资项目';
						this.rankTypeList = this.tzxmRankTypeList;
					} else if (newValue == 3) {
						this.chartText = '融资项目';
						this.rankTypeList = this.rzxmRankTypeList;
					} else if (newValue == 4) {
						this.chartText = '拿地项目';
						this.rankTypeList = this.ndxmRankTypeList;
					} else if (newValue == 5) {
						this.chartText = '创投项目';
						this.rankTypeList = this.ctxmRankTypeList;
					}
				}
				this.PiechartFun('fixedEchartPie', this.provinceInvestType);
				// this.rankFun('fixedEchartBar');
				this.rankTrunData(this.rankTypeList[0]);
			}
		},


	},
	beforeCreate() {
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		var _this = this;
		this.userdata = this.getuseriformation();
		if (this.userdata.groupType != 1) { //1正式 2免费 0试用
			this.isshowWaterMark = true;
		}
		if (this.$route.query.type) { // 从详情页进入需要判断要进入哪个页面
			this.pageType = this.$route.query.type;
			this.pageType == 3 ? this.marktetType = 2 : this.marktetType = 1;
		}
		if (this.$route.query.code) { // 从详情页进入赋值并且不需要去请求后台数据，会从notionScreen传回数据再去请求后台
			this.link_notionCode = this.$route.query.code;
			this.notionCode = this.link_notionCode;
		} else {
			this.choosePageType(this.pageType);
		}
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		document.title = this.title + "-产业研究"
		var _this = this;
		this.allDataOptionsClick(1, this.allDataOptions[0]);
	},
	methods: {
		industryClilk(item){
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			this.dataType = item.value; 
			this.getIndustyrDataList();
		},
		//获取经营数据 data_type 1=年度经营数据,3=月度经营数据,4=季度生产数据,7=研发创新数据
		getOperate(data_type) {
			this.bus.$emit('loading', true);
			let _this = this;
			let notionCode = this.splicing('notionCode', this.notionCode);
			let ajaxUrl = this.$api.cyl.allIndustryData.operate() + '?dataType=' + data_type + notionCode;
			this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log(ajaxUrl, res);
				if (res.data.success) {
					_this.alltableData = res.data.list;
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取价格变化 data_type 1国家-年度 2国家-月度
		getPriceChange(data_type) {
			this.bus.$emit('loading', true);
			let _this = this;
			let notionCode = this.splicing('notionCode', this.notionCode);
			let ajaxUrl = this.$api.cyl.allIndustryData.priceChange() + '?dataType=' + data_type + notionCode;
			this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log(ajaxUrl, res);
				if (res.data.success) {
					_this.alltableData = res.data.list;
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//产业数据库整合一级菜单点击
		allDataOptionsClick(step, item) {
			console.log(item,this.allDataOptions[0].value,item.value);
			if(!this.userdata.token && item.value != this.allDataOptions[0].value){
				this.isShowFreeUserTips = true;
				return;
			}
			if (step == 1) {
				this.allDataTitle = item.label;
				this.allDataValue1 = item.value;
				this.allDataOptions2 = item.children;
				this.allDataValue2 = item.children[0].value;
			} else if (step == 2) {
				this.allDataValue2 = item.value;
			}
			this.chekGetData();
		},
		chekGetData() {
			if (this.allDataValue1 == 1) {
				if (this.allDataValue2 == 1 || this.allDataValue2 == 2) { //市场规模，竞争格局
					this.marktetType = this.allDataValue2 == 2 ? 2 : 1;
					this.routerUrl = this.allDataValue2 == 2 ? '/marketDetail?type=2&id' : '/marketDetail?type=1&id';
					this.getMarketList();
				} else if (this.allDataValue2 == 3) { //产品产量
					this.getProductList();
					this.routerUrl = '';
				} else if (this.allDataValue2 == 4) { //年度价格变化
					this.getPriceChange(1);
					this.routerUrl = '/bureauStatisticsDetail?type=1&code=';
				} else if (this.allDataValue2 == 5) { //月度价格变化
					this.getPriceChange(3);
					this.routerUrl = '';
				}
			} else if (this.allDataValue1 == 2) {
				this.getOperate(this.allDataValue2);
				this.routerUrl = '';
			}else if(this.allDataValue1 == 3){
				this.ajaxsearchcompany();
			}
		},
		clickToView(item){
			if (this.allDataValue1 == 1) {
				if (this.allDataValue2 == 1 || this.allDataValue2 == 2) { //市场规模，竞争格局
					this.routerUrl = this.allDataValue2 == 2 ? '/marketDetail?type=2&id=' : '/marketDetail?type=1&id=';
					this.routerblank(this.routerUrl + item.id);
				} else if (this.allDataValue2 == 3) { //产品产量
					this.routerUrl = '/bureauStatisticsDetail?type=8&dataType=8&code=';
					this.routerblank(this.routerUrl + item.code);
				} else if (this.allDataValue2 == 4) { //年度价格变化
					this.routerUrl = '/bureauStatisticsDetail?type=1&dataType=1&code=';
					this.routerblank(this.routerUrl + item.code);
				} else if (this.allDataValue2 == 5) { //月度价格变化
					this.routerUrl = '/bureauStatisticsDetail?type=3&dataType=3&code=';
					this.routerblank(this.routerUrl + item.code);
				}
			} else if (this.allDataValue1 == 2) {
				if (this.allDataValue2 == 1 ) {
					this.routerUrl = '/bureauStatisticsDetail?type=1&dataType=1&code=';
				} else if (this.allDataValue2 == 3 ) {
					this.routerUrl = '/bureauStatisticsDetail?type=3&dataType=3&code=';
				}else if(this.allDataValue2 == 4){
					this.routerUrl = '/bureauStatisticsDetail?type=4&dataType=4&code=';
				}else if(this.allDataValue2 == 7){
					this.routerUrl = '/bureauStatisticsDetail?type=5&dataType=7&code=';
				}
					this.routerblank(this.routerUrl + item.code)
			}else if(this.allDataValue1 == 3){
					this.routerUrl = '/industryDetail?type='+item.title+'&code='+this.notionCode;	
					this.routerblank(this.routerUrl)
			}
			
		},
		//获取后台行业数据库列表
		getIndustyrDataList(pages) {
			this.page = pages ? pages : 1;
			this.bus.$emit('loading', true);
			let _this = this;
			let notionCode = this.splicing('notionCode', this.notionCode);
			let dataType = this.splicing('dataType', this.dataType);
			let ajaxUrl = this.$api.cyl.statsData.list() + '?page=' + this.page + notionCode + dataType;
			this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log(ajaxUrl, res);
				if (res.data.success) {
					console.log('行业数据库 列表数据', res);
					_this.industyrDataList = res.data.data.list;
					_this.$nextTick(() => {
						const filteredList = _this.industyrDataList.map(item => {
							// 过滤掉data数组中value为0的项
							const filteredData = item.data.filter(dataItem => dataItem.value !== 0);
							// 如果过滤后的data数组长度为0，则不包含该项
							if (filteredData.length === 0) {
								return null;
							}
							// 否则，返回更新后的项
							return {
								...item,
								data: filteredData
							};
						}).filter(item => item !== null);
						_this.industyrDataList = filteredList;
						// 绘制图表
						_this.industyrDataList.forEach((list, i) => {
							// console.log(list.data.length > 0,list.data,list.title);
							_this.drawShape('indutry_charts_' + i, list.data, list.title, list.unit);
						})
					})
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//匹配折线图的数据，用所选项去匹配
		rankTrunData(item) {
			console.log(item);
			this.rankType = item.value;
			let data = [];
			this.enterpristlist.forEach((list) => {
				console.log('list', list.title, item.label);
				if (list.title == item.text) {
					// console.log('list.title',list);
					data = list.data;
				}
			});
			this.rankFun('fixedEchartBar', data);

		},
		getIndustryLibrayChartData() {
			this.bus.$emit('loading', true);
			let _this = this;
			let industryCode = this.splicing('industryCode', this.notionCode);
			let year = this.splicing('year', this.years);
			let ajaxUrl = this.$api.cyl.industryData.areaList() + '?industryType=1' + industryCode + year; // 24.3.27改为只用先进制造业，去掉制造业（国民经济分类）
			this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log(ajaxUrl, res);
				if (res.data.success) {
					// console.log('产业分布图 列表数据', res);
					_this.provinceChartData = res.data.data.province;
					_this.cityChartData = res.data.data.city;
					_this.PiechartFun('fixedEchartPie', _this.provinceInvestType);
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//弹出图表 概念企业数量排名
		rankFun(el, data) {
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();
			let xline = [], seriesline = [];

			for (var i = data.length - 1; i >= 0; i--) { //要按从小到大年份排序
				// console.log('data',data[i]);
				xline.push(data[i].year);
				seriesline.push(data[i].value);
			};
			// console.log('折线图',data, xline, seriesline)
			var option = {
				tooltip: {
					formatter: "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff'></span>{b}：{c}"
				},
				xAxis: {
					type: 'category',
					data: xline
				},
				yAxis: {
					type: 'value'
				},
				series: [{
					data: seriesline,
					type: 'line',
					smooth: true
				}]
			};
			this.mychart.setOption(option);
			var startCharts = null;
		},
		PiechartFun(el, type, data) {
			if (this.statisticalValue == 0) {  //全部和产品产量没有图表数据 || this.statisticalValue == 5
				return;
			}
			console.log('piechart', el, type, data);
			this.provinceInvestType = type;
			if (type == 1) {
				data = this.provinceChartData;
			} else if (type == 2) {
				data = this.cityChartData;
			}
			// 分离不满足条件的元素（title 不为 创投项目）  因为后台传回来的顺序不一样
			let inactiveItems = data.filter(item => item.title != '创投项目数量');

			// 分离满足条件的元素（title 为 创投项目）  
			let activeItems = data.filter(item => item.title == '创投项目数量');

			// 合并数组，不满足条件的元素在前，满足条件的元素在后  
			data = [...inactiveItems, ...activeItems];
			console.log('data', data);
			let chartData = data[this.statisticalValue - 1].areaData;
			console.log('chartdata', data[this.statisticalValue - 1]);
			var charPie3currentIndex = 0,
				isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();
			let newdata = [], otherNum = 0;
			for (var i = 0; i < chartData.length; i++) {
				if (i < 10) {
					newdata.push({ name: chartData[i].name, value: chartData[i].value });
				} else {
					otherNum = otherNum + chartData[i].value;
				}
			}
			newdata.push({ name: '其他', value: otherNum });
			var that = this;
			var option = {
				title: {
					text: ' ',
				},
				tooltip: {
					trigger: 'item'
				},
				// legend: {top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形
				// },
				series: [{
					name: '',
					type: 'pie',
					radius: '60%',
					// center: ["52%", "50%"],
					data: newdata,
					label: {
						show: true,
						color: '#333',
						fontSize: 12,
						position: 'outside',
						formatter: '{b} : {d}%',
					},
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					}
				}]
			};
			this.mychart.setOption(option);
		},

		//选择页面类型
		choosePageType(value) {
			this.pageType = value;
			this.showechart = false; //关闭图表
			this.refreshNum_watermark++;
			this.clearNotion();//页面变化清空所选择的概念
			this.resultType = 0;
			if (this.pageType == 2 || this.pageType == 3) {
				this.marktetType = this.pageType - 1;
				this.getMarketList();
			} else if (this.pageType == 4) {
				this.getProductList();
			} else if (this.pageType == 1) {
				console.log('产业分布');
				this.ajaxsearchcompany();
				this.notioncodeList_data = {};
			} else if (this.pageType == 5) {
				this.getIndustyrDataList();
			} else if (this.pageType == 0) {
				this.resultType = 1;
			}
		},
		//清空概念选项
		clearNotion() {
			this.notionNumRefresh++;
			this.isClearNotion = true;
			this.notionCode = 'A';
		},
		// 获取市场竞争列表
		getMarketList(pages) {
			this.page = pages ? pages : 1;
			this.bus.$emit('loading', true);
			var _this = this;
			let notionCode = this.splicing('notionCode', this.notionCode);
			let ajaxUrl = this.$api.common.market.list() + '?type=' + this.marktetType + notionCode + '&page=' + this.page + '&resultType=' + this.resultType;
			this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log(ajaxUrl, res);
				if (res.data.success) {
					console.log(_this.marktetType == 1 ? '市场规模列表' : '竞争格局列表', res.data.list);
					if (_this.resultType == 1) {
						_this.alltableData = res.data.list;
					} else {
						_this.marketList = res.data.list;
						_this.notioncodeList_data = res.data.data.dict;

						_this.$nextTick(() => {
							if (_this.pageType == 2) {
								_this.marketList.forEach((list, i) => {
									let isFlag = list.dataMap && !Array.isArray (list.dataMap) && Object.keys(list.dataMap).length > 0 && Object.keys(list.dataMap).every(key => key.trim() !== '') ;
									_this.drawShape('bar_charts_' + i, isFlag?list.dataMap : list.dataList, list.legendName, list.unit);
								})
							} else {
								_this.marketList.forEach((list, i) => {
									_this.pieCharts('pie_charts_' + i, list.dataList, list.unit);
								})
							}

						})
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
					}

					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});

		},
		//概念单选 层级显示
		chooseNotion(chooseNotionlist, notionCode, step) {
			// console.log(chooseNotionlist,notionCode);
			this.notionCode = notionCode;
			if (step) {
				this.notionstep = step;
			}
			var sortStr = (step && step < 3) ? 'sort' : '';
			if (this.pageType == 1) {
				this.ajaxsearchcompany(1, sortStr);

			} else if (this.pageType == 3 || this.pageType == 2) {
				this.getMarketList(1);
			} else if (this.pageType == 4) {
				this.getProductList();
			} else if (this.pageType == 5) {
				this.getIndustyrDataList();
			} else if (this.pageType == 0) {
				this.chekGetData();
			}
		},
		//有小数点四舍五入保留两位小数，没小数点不变
		toFixedFn(number) {
			let fixedNum;
			if (number && String(number).indexOf('.') !== -1) {
				fixedNum = number.toFixed(2);
			} else {
				fixedNum = number;
			}
			return fixedNum;
		},

		pageHandler(page) {
			this.page = page;
			if (this.pageType == 2 || this.pageType == 3) {
				this.getMarketList(page);
			} else if (this.pageType == 4) {
				this.getProductList(page);
			} else if (this.pageType == 5) {
				this.getIndustyrDataList(page);
			}
		},
		ajaxsearchcompany(pages) {
			this.bus.$emit('loading', true);
			var _this = this;
			let industryCode = this.splicing('industryCode', this.notionCode);
			let ajaxUrl = this.$api.cyl.industryData.list() + '?industryType=1' + industryCode; // 24.3.27改为只用先进制造业，去掉制造业（国民经济分类）
			this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log('投融资数据',ajaxUrl, res);
				if (res.data.success) {
					if (_this.pageType == 0) {
						let list = res.data.list;
						let arr = [];
						for (let i = 0; i < list.length; i++) { //因为后台传回来的数据是整个列表，在前端页面只需要单个线上
							list[i].startTime = '2018';
							list[i].endTime = '2024';
							if(_this.allDataValue1 ==3){
								if( _this.allDataValue2 == 1){
								if(list[i].title == '上市公司数' || list[i].title == '总营业收入' || list[i].title =='总净利润'|| list[i].title =='总研发费用'){
									arr.push(list[i]);
								}
								}else if(_this.allDataValue2 == 2){
									if(list[i].title == '投资项目数量' || list[i].title == '投资项目金额'){
										arr.push(list[i]);
									}
								}else if( _this.allDataValue2 == 3){
									if(list[i].title == '融资项目数量' || list[i].title == '融资项目金额'){
										arr.push(list[i]);
									}
								}else if( _this.allDataValue2 == 4){
									if(list[i].title == '拿地项目数量' || list[i].title == '拿地项目金额' || list[i].title == '拿地项目面积'){
										arr.push(list[i]);
									}
								}else if( _this.allDataValue2 == 5){
									if(list[i].title == '创投项目数量' || list[i].title == '创投项目金额' ){
										arr.push(list[i]);
									}
								}
								}
							
						}
						_this.alltableData = arr;

					} else {
						console.log('列表数据', res.data.list);
						_this.enterpristlist = res.data.list;
						_this.getIndustryLibrayChartData();
						_this.notioncodeList_data = {};
						if (_this.rankTypeList.length) {
							_this.rankTrunData(_this.rankTypeList[0]);
						}
						// _this.getProductList();
					}

					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		getProductList(pages) {
			this.page = pages ? pages : 1;
			this.bus.$emit('loading', true);
			var _this = this;
			console.log('产品产量id', this.notionCode);
			let industryCode = this.splicing('industryCode', this.notionCode);
			let ajaxUrl = this.$api.cyl.industryData.list2() + '?industryType=1' + industryCode + '&page=' + this.page + '&resultType=' + this.resultType;
			this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log(ajaxUrl, res);
				if (res.data.success) {
					console.log('产品产量列表数据', res);
					if (_this.resultType == 1) {
						_this.alltableData = res.data.data.product;
					} else {
						_this.productList = res.data.data.product;
						_this.notioncodeList_data = res.data.data.dict;
						_this.$nextTick(() => {
							_this.productList.forEach((list, i) => {
								list.data = list.data.filter((item) => { //剔除没数据的年份列表
									return item.value != 0;
								})
								list.data.reverse(); //反转年份，从小到大
								_this.drawShape('cp_charts_' + i, list.data, list.title, list.unit);
							})
						})
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
					}

					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		barChart(el, data, unit, type) {
			console.log('柱状图', data);
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();

			// 提取数据
			const labels = [];
			const series = [];
			const yAxisList = []; // 用于存储 Y 轴配置

			// 定义柱状图颜色数组
			const barColors = ['#5470C6', '#91CC75', '#EE6666', '#FAC858', '#73C0DE', '#3BA272', '#FC8452', '#9A60B4', '#E488C1'];
			let barColorIndex = 0; // 用于循环分配柱状图颜色

			// 定义折线图颜色数组
			const lineColors = ['#FAC858', '#73C0DE', '#3BA272', '#FC8452', '#9A60B4', '#E488C1', '#5470C6', '#91CC75', '#EE6666'];
			let lineColorIndex = 0; // 用于循环分配折线图颜色

			// 遍历 dataMap
			for (const key in data) {
				if (data.hasOwnProperty(key)) {
					const dataList = data[key];

					// 提取 label（年份）
					if (labels.length === 0 && dataList && dataList.length > 0) {
						for (let i = 0; i < dataList.length; i++) {
							if (dataList[i].label) {
								labels.push(dataList[i].label);
							}
						}
					}

					// 获取当前数据的单位
					const currentUnit = (dataList && dataList[0] && dataList[0].unit) || '';

					// 根据单位决定图表类型
					const chartType = currentUnit === '%' ? 'line' : 'bar';
					// 为柱状图和折线图分配不同的颜色
					const color = chartType === 'bar' ? barColors[barColorIndex % barColors.length] : lineColors[lineColorIndex % lineColors.length];
					if (chartType === 'bar') {
						barColorIndex++; // 更新柱状图颜色索引
					} else {
						lineColorIndex++; // 更新折线图颜色索引
					}

					// 添加 series
					series.push({
						name: key + ' (' + currentUnit + ')', // 在图例中显示单位
						type: chartType,
						yAxisIndex: yAxisList.length, // 指定 Y 轴索引
						data: dataList.map(function (item) {
							return {
								value: item.data,
								unit: currentUnit // 保存单位到数据点
							};
						}),
						itemStyle: { color: color },
						lineStyle: chartType === 'line' ? {
							width: 3
						} : undefined,
						...(chartType === 'line' ? {
							symbol: 'circle',
							symbolSize: 6
						} : {
							barMaxWidth: 30
						})
					});

					// 添加 Y 轴配置
					yAxisList.push({
						type: 'value',
						name: currentUnit, // Y 轴名称显示单位
						position: chartType === 'line' ? 'right' : 'left', // 折线图 Y 轴在右侧，柱状图 Y 轴在左侧
						axisLabel: {
							formatter: function (value) {
								return value;
							}
						},
						splitLine: {
							show: yAxisList.length === 0, // 只在第一个 Y 轴显示背景刻度线
							lineStyle: {
								type: 'dashed'
							}
						}
					});
				}
			}

			// 检查是否所有数据都是柱状图且单位相同
			const allBarsSameUnit = series.every(s => s.type === 'bar' && s.name.endsWith(`(${unit})`));

			// 如果所有数据都是柱状图且单位相同，只保留一个 Y 轴
			if (allBarsSameUnit) {
				yAxisList.length = 1; // 只保留第一个 Y 轴
				series.forEach(s => {
					s.yAxisIndex = 0; // 将所有系列的 Y 轴索引设置为 0
				});
			}

			// 分离柱状图和折线图的图例
			const barSeries = series.filter(s => s.type === 'bar');
			const lineSeries = series.filter(s => s.type === 'line');
			const legendData = barSeries.map(s => s.name).concat(lineSeries.map(s => s.name));

			// 配置项
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: { type: 'cross' },
					formatter: function (params) {
						var result = params[0].name + '<br/>';
						for (var i = 0; i < params.length; i++) {
							var item = params[i];
							var unit = (item.data && item.data.unit) || '';
							result += item.marker + ' ' + item.seriesName.split(' (')[0] + ': ' + item.value + ' ' + unit + '<br/>';
						}
						return result;
					}
				},
				legend: {
					data: legendData, // 柱状图图例在前，折线图图例在后
					bottom: 10,
					itemGap: 20
				},
				grid: {
					top: '15%',
					right: '10%', // 增加右边距以容纳右侧 Y 轴
					left: '10%', // 增加左边距以容纳左侧 Y 轴
					bottom: '15%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: labels,
					axisLabel: {
						interval: 0,
						rotate: labels.length > 5 ? 45 : 0,
						margin: 15
					}
				},
				yAxis: yAxisList, // 使用动态生成的 Y 轴配置
				series: series
			};

			this.mychart.setOption(option);
		},
		drawShape(el, data, legendName, unit) {
			console.log(el, data, legendName, unit);
			let isFlag =  !Array.isArray (data)  && Object.keys(data).length > 0 && Object.keys(data).every(key => key.trim() !== '') ;
			console.log(isFlag,data);
			if(isFlag){
				this.$nextTick(()=>{
					// setTimeout(() => {
						this.barChart(el, data, unit, 'show');
					// }, 3000);
					
				})
				return;
			}
			
			if (this.pageType == 2) {
				data.sort((a, b) => {
					a.text = a.label;
					b.text = b.label;
					b.text = b.text.replace('E', '');
					a.text = a.text.replace('E', '');
					return b.text - a.text; // 降序排序
				});
				data = data.slice(0, 10);
				// console.log('市场规模排序后',data);
			}
			let xAxisText = [];
			let barData = [], //柱状
				lineData = []; //折线
			for (var i = 0; i < data.length; i++) {

				if (this.pageType == 2) {
					xAxisText.push(data[i].label);
					barData.push(data[i].value);
					lineData.push(data[i].tb);
				} else if (this.pageType == 4) {
					xAxisText.push(data[i].year);
					barData.push(data[i].value);
					lineData.push(data[i].growth);
				} else if (this.pageType == 5) {

					let tempStr = '';
					// xAxisText.push(data[i].year);
					if (this.dataType == 1) { //1年度 3月度 4季度
						tempStr = data[i].year + "年";
						xAxisText.push(tempStr);
					} else if (this.dataType == 3) {
						tempStr = data[i].year + '-' + data[i].month + '月';
						xAxisText.push(tempStr);
					} else if (this.dataType == 4) {
						tempStr = data[i].year + '-' + data[i].quarter + '季度';
						xAxisText.push(tempStr);
					}

					barData.push(data[i].value);
					lineData.push(data[i].growth);
				}
			}
			//因为要从大到小按年份提取10条数据，所以前面按照从大到小排序了，但是柱状图又要从小到大排序，所以这里反转一下数据
			if (this.pageType == 2 || this.pageType == 5) {
				// 反转数据年份从小到大排序
				xAxisText.reverse();
				barData.reverse();
				lineData.reverse();
			}

			// 创建立方体正面图形
			const cubeShape1 = echarts.graphic.extendShape({
				shape: {
					x: 0,
					y: 0,
					width: 10, // 长方体宽度
					zWidth: 2, // 阴影折角高
					zHeight: 4 // 阴影折角宽
				},
				buildPath: (ctx, shape) => {
					const api = shape.api
					const xAxisPoint = api.coord([shape.xValue, 0])
					const p0 = [shape.x, shape.y]
					const p1 = [shape.x - shape.width, shape.y]
					const p4 = [shape.x + shape.width, shape.y]
					const p2 = [
						xAxisPoint[0] - shape.width,
						xAxisPoint[1]
					]
					const p3 = [
						xAxisPoint[0] + shape.width,
						xAxisPoint[1]
					]

					// 绘制正面
					ctx.moveTo(p0[0], p0[1]) //0
					ctx.lineTo(p1[0], p1[1]) //1
					ctx.lineTo(p2[0], p2[1]) //2
					ctx.lineTo(p3[0], p3[1]) //3
					ctx.lineTo(p4[0], p4[1]) //4
					ctx.lineTo(p0[0], p0[1]) //0
					ctx.closePath()
				}
			})

			// 创建立方体的侧面
			const cubeShape2 = echarts.graphic.extendShape({
				shape: {
					x: 0,
					y: 0,
					width: 10, // 长方体宽度
					zWidth: 4, // 阴影折角高
					zHeight: 1 // 阴影折角宽
				},
				buildPath: (ctx, shape) => {
					const api = shape.api
					const xAxisPoint = api.coord([shape.xValue, 0])
					const p4 = [shape.x + shape.width, shape.y]
					const p6 = [
						shape.x + shape.width + shape.zWidth,
						shape.y - shape.zHeight
					]
					const p3 = [
						xAxisPoint[0] + shape.width,
						xAxisPoint[1]
					]
					const p5 = [
						xAxisPoint[0] + shape.width + shape.zWidth,
						xAxisPoint[1] - shape.zHeight
					]

					// 绘制侧面
					ctx.moveTo(p4[0], p4[1]) //4
					ctx.lineTo(p3[0], p3[1]) //3
					ctx.lineTo(p5[0] + 6, p5[1] - 6) //5
					ctx.lineTo(p6[0] + 7, p6[1] - 8) //6
					ctx.lineTo(p4[0], p4[1]) //4
					ctx.closePath()
				}
			})
			// 创建立方体的顶
			const cubeShape3 = echarts.graphic.extendShape({
				shape: {
					x: 0,
					y: 0,
					width: 10,
					zWidth: 4,
					zHeight: 1
				},
				buildPath: (ctx, shape) => {
					const api = shape.api
					const p1 = [shape.x - shape.width, shape.y]
					const p4 = [shape.x + shape.width, shape.y]
					const p6 = [
						shape.x + shape.width + shape.zWidth,
						shape.y - shape.zHeight
					]
					const p7 = [
						shape.x - shape.width + shape.zWidth,
						shape.y - shape.zHeight
					]
					// 绘制顶部
					ctx.moveTo(p4[0], p4[1]) //4
					ctx.lineTo(p6[0] + 7, p6[1] - 8) //6
					ctx.lineTo(p7[0] + 7, p7[1] - 8) //7
					ctx.lineTo(p1[0], p1[1]) //1
					ctx.lineTo(p4[0], p4[1]) //4
					ctx.closePath()
				}
			})

			echarts.graphic.registerShape('cubeShape1', cubeShape1);
			echarts.graphic.registerShape('cubeShape2', cubeShape2);
			echarts.graphic.registerShape('cubeShape3', cubeShape3);
			this.$nextTick(() => {
				if (this.pageType == 2) {
					this.initECharts(el, xAxisText, lineData, barData, legendName, unit);
				} else if (this.pageType == 4 || this.pageType == 5) {
					this.cpclChart(el, xAxisText, lineData, barData, legendName, unit);
				}
			})
			
		},
		initECharts(el, xdata, lineData, barData, legendName, unit) {
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();

			// 检查数据是否全部为0
			const isBarDataAllZero = barData.every(item => item === 0 || item === null);
			const isLineDataAllZero = lineData.every(item => item === 0 || item === null);

			// 过滤数据：将数值为0的数据点设置为null
			const filteredBarData = barData.map(item => item === 0 ? null : item);
			const filteredLineData = lineData.map(item => item === 0 ? null : item);

			// 动态生成 series 数据
			const series = [];
			if (!isBarDataAllZero) {
				series.push({
					type: 'custom',
					name: legendName + (this.pageType == 2 ? '' : '(' + unit + ')'),
					color: 'rgb(96, 147, 218)',
					renderItem: (params, api) => {
						let location = api.coord([api.value(0), api.value(1)]);
						return {
							type: 'group',
							children: [
								{
									type: 'cubeShape1',
									shape: {
										api,
										xValue: api.value(0),
										yValue: api.value(1),
										x: location[0],
										y: location[1]
									},
									style: {
										fill: 'rgb(96, 147, 218)'
									}
								},
								{
									type: 'cubeShape2',
									shape: {
										api,
										xValue: api.value(0),
										yValue: api.value(1),
										x: location[0],
										y: location[1]
									},
									style: {
										fill: 'rgb(84,128,191)'
									}
								},
								{
									type: 'cubeShape3',
									shape: {
										api,
										xValue: api.value(0),
										yValue: api.value(1),
										x: location[0],
										y: location[1]
									},
									style: {
										fill: 'rgb(104, 161, 236)'
									}
								}
							]
						};
					},
					yAxisIndex: 0,
					data: filteredBarData,
				});
			}
			if (!isLineDataAllZero) {
				series.push({
					name: 'YOY',
					type: 'line',
					yAxisIndex: 1,
					color: '#ffaf25',
					data: filteredLineData
				});
			}

			// 动态生成图例数据
			const legendData = [];
			if (!isBarDataAllZero) {
				legendData.push(legendName + (this.pageType == 2 ? '' : '(' + unit + ')'));
			}
			if (!isLineDataAllZero) {
				legendData.push('YOY');
			}

			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					appendToBody: true, // 是否将提示框放置在body元素上
					formatter: function (params) {
						let result = '';
						let name = params[0].name + "</br>";
						let dotHtml = '', dotHtml2 = '', unitd = params[0].componentSubType === "line" ? ' %' : unit;

						if (params[0]) {
							dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[0].color + '"></span> ' + params[0].seriesName + "： " + (params[0].data !== null ? params[0].data : '-') + ' ' + unitd + "</br>";
						}
						if (params[1]) {
							dotHtml2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[1].color + '"></span>' + params[1].seriesName + "： " + (params[1].data !== null ? params[1].data : '-') + ' %';
						}

						result += name + dotHtml + dotHtml2;
						return result;
					},
				},
				legend: {
					show: legendData.length > 0, // 如果没有数据，则不显示图例
					bottom: "5%",
					data: legendData
				},
				xAxis: {
					type: 'category',
					data: xdata,
					interval: 0,
					axisLine: {
						onZero: false,
					}
				},
				yAxis: [
					{
						type: 'value',
						name: '',
						boundaryGap: false,
						axisTick: {
							show: true
						},
						axisLine: {
							show: true,
						},
						splitLine: {
							show: true, // 始终显示背景线
							lineStyle: {
								type: 'dashed' // 虚线样式
							}
						},
					},
					{
						type: 'value',
						name: ' ',
						axisTick: {
							show: true
						},
						splitLine: {
							show: false, // 始终显示背景线
							lineStyle: {
								type: 'dashed' // 虚线样式
							}
						},
						axisLine: {
							show: true,
						},
						axisLabel: {
							formatter: '{value} %'
						}
					}
				],
				series: series
			};

			this.mychart.setOption(option);
		},
		cpclChart(el, xdata, lineData, barData, legendName, unit) {
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();
			let min = Math.floor(Math.min(...barData));
			let max = Math.floor(Math.max(...barData));
			let lineMin = Math.floor(Math.min(...lineData));
			let lineMax = Math.floor(Math.max(...lineData));
			let range = max - min;
			min = min - (range / 1)
			// console.log(min,max,range);
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					grid: {
						top: '100%',
						// containLabel: true // 包含标签
					},
					// confine:true, //是否将提示框限制在图表的区域内
					appendToBody: true, //是否将提示框放置在body元素上
					formatter: function (params) {
						// console.log(params);
						var result = ''
						var name = params[0].name + "</br>";
						var dotHtml = '', dotHtml2 = '', unitd = params[0].componentSubType == "line" ? ' %' : unit;
						if (params[0]) {
							dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[0].color + '"></span> ' + params[0].seriesName + "： " + params[0].data + ' ' + unitd + "</br>"; // 定义第一个数据前的圆点颜色	
						}
						if (params[1]) {
							dotHtml2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[1].color + '"></span>' + params[1].seriesName + "： " + params[1].data + ' %';
						}

						result += name + dotHtml + dotHtml2;
						return result
					},
				},
				legend: {
					show: true,
					bottom: "5%",
				},
				xAxis: {
					type: 'category',
					data: xdata,
					interval: 0,
					axisLine: {
						onZero: false,
					}
					// axisLabel: { color: '#333', interval: 0, rotate: 50 }
				},
				yAxis: [
					{
						type: 'value',
						name: '',
						minInterval: 1,
						min: min,
						boundaryGap: false,
						// step:
						axisTick: {
							"show": true
						},
						axisLine: {
							show: true,
						}, //显示y轴刻度线
						splitLine: {
							show: false
						}, //不显示分割线
					},
					{
						type: 'value',
						name: ' ',
						min: lineMin,
						boundaryGap: false,
						axisTick: {
							"show": true
						},
						splitLine: {
							show: false
						}, //不显示分割线
						axisLine: {
							show: true,
						}, //显示y轴刻度线
						axisLabel: {
							// 使用 formatter 属性来格式化标签文本
							formatter: '{value} %' // 在这里添加单位
						}
					}
				],
				series: [
					{
						type: 'bar',
						name: legendName,
						color: 'rgb(96, 147, 218)',
						yAxisIndex: 0, // 这里指定使用第一个 Y 轴
						data: barData,
						barMaxWidth: 30,
					},
					{
						name: 'YOY',
						type: 'line',
						yAxisIndex: 1,
						color: '#ffaf25',
						data: lineData
					}
				]
			}
			this.mychart.setOption(option)

		},
		pieCharts(el, data, unit) {
			// console.log(el,data);
			let seriesData = [];
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();
			for (var i = 0; i < data.length; i++) {
				data[i].name = data[i].label;
				if (data[i].label == '其他') {
					var ortherData = data[i]
					// console.log(data[i]);
				} else {
					seriesData.push(data[i]);
				}
			}
			if (typeof ortherData === 'object' && ortherData !== null && Object.keys(ortherData).length > 0) {
				seriesData.push(ortherData);
				// console.log(ortherData,seriesData,data);
			}
			var option = {
				tooltip: {
					trigger: 'item',
					formatter: '{b0}: {c0} ' + unit
				},
				color: this.colors,
				legend: {
					right: '0',
					top: 'center',
					orient: 'vertical', // 设置图例竖排
					type: 'scroll', //图例强制不换行（滚动）
					width: '70%',
					formatter: (name) => {
						// console.log(name);
						if (!name) return '';
						let tempStr = this.getEqualNewlineString(name, 10);
						for (let i = 0; i < seriesData.length; i++) {
							// console.log(seriesData[i].name,name);
							if (seriesData[i].name == name && seriesData[i].stockCode != 0) {
								return '{a|' + tempStr + '}'; // 使用{a|text}语法来表示下划线
							} else if (seriesData[i].name == name && seriesData[i].stockCode == 0) {
								return tempStr;

							}
						}
					},
					textStyle: {
						rich: {
							a: {
								color: '#598df5',
								lineHeight: 22,
								align: 'center',
								fontSize: 12,
								borderWidth: 0.5,
								decoration: 'underline' // 设置下划线
							}
						}
					}
				},
				series: [
					{
						name: '',
						type: 'pie',
						// radius: ['40%', '70%'],
						center: ['35%', '50%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						labelLine: {
							show: false
						},
						data: seriesData,
						itemStyle: {
							normal: {
								borderColor: '#ffffff', // 发光颜色
								// borderWidth: 5,       // 发光宽度
								// shadowBlur: 10,       // 阴影模糊大小
								// shadowColor: '#f7f3ff'  // 阴影颜色
							}
						},
					}
				],
			};
			this.mychart.setOption(option);
			// 饼图图例点击跳转到指定页面
			this.mychart.on('legendselectchanged', (param) => {

				// console.log(param)
				for (let i = 0; i < seriesData.length; i++) {
					if (param.name == seriesData[i].name && seriesData[i].stockCode != 0 && seriesData[i].table != 0) {
						this.mychart.setOption({
							legend: { selected: { [param.name]: true } } //让图例点击后不变灰
						});
						if (seriesData[i].table != 4) {
							let url = this.userdata.groupType != 2 ? '/enterprises' : '/enterprises-free';
							this.routerlinkid(url, seriesData[i].stockCode);
						} else {
							this.routerlinkid('/enterprisesF', seriesData[i].stockCode);
						}
					}
				}
			});
			this.mychart.on('click',  (param)=> {
				console.log(param)
				if(param.data.stockCode !=''&& param.data.table != 0){
					if(param.data.table != 4){
						this.routerlinkid('/enterprises',param.data.stockCode);
					}else {
						this.routerlinkid('/enterprisesF',param.data.stockCode);
					}
				}
			});
		},
		//params 要处理的字符串
		//length 每行显示长度
		getEqualNewlineString(params, length) {
			let text = ''
			let count = Math.ceil(params.length / length) // 向上取整数
			// 一行展示length个
			if (count > 1) {
				for (let z = 1; z <= count; z++) {
					text += params.substr((z - 1) * length, length)
					if (z < count) {
						text += '\n'
					}
				}
			} else {
				text += params.substr(0, length)
			}
			return text
		},

	},

}
</script>

<style>
.dialog-pop-market .el-dialog__headerbtn .el-dialog__close {
	color: #4c4c4d;
	font-size: 30px;
}
</style>
<style scoped>
.container-flex-center img {
	max-width: 95%;
	max-height: 95%;
}

.el-dialog__headerbtn {
	font-size: 30px;
	font-weight: bold;
}

.pop-box {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	border: 1px solid red;
	z-index: 99999;
}

.market-list {
	width: calc(33% - 35px);
	height: 365px;
	cursor: pointer;
	overflow: hidden;
	transition: all .3s;
	border: 1px solid #eee;
	margin-right: 35px;
	border-radius: 8px;
}

.market-list:hover {
	/* background: #f3f7ff; */
	border-radius: 8px;

}

.image-card {
	height: 270px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.market-list .img {
	/* width: calc(100% - 40px);
		height: 100%; */
	margin: 0 auto;
	padding: 10px 0 8px;
	max-width: 90%;
	max-height: 100%;
}

.market-title {
	padding: 20px 20px 0 20px;
	height: 48px;
	/* display: flex; */
	/* align-items: center; */
	/* overflow: hidden; */
}

.font-size14 {
	font-size: 14px;
}

.text-left {
	text-align: left;
}

.pr-2 {
	padding-left: 20px !important;
}

.pt-3 {
	padding-top: 30px;
}

.py-col-15 {
	padding: 15px 0 15px 20px !important;
}

.text-dent {
	/* text-indent:2em; */
	padding-left: 35px !important;
}

.min-widht130 {
	min-width: 130px !important;
}

.width50PC {
	width: 100px;
}

.inline-block {
	display: inline-block;
	padding: 15px 10px;
	word-wrap: break-word;
	/* border-right: 1px solid #ececec; */
}

.table-min-width {
	min-width: 2000px;
}

.growth_table td {
	padding: 0;
	align-items: center;
	vertical-align: middle;
	min-width: 200px;

}

.growth_table {
	min-width: 2000px;
	width: 100%;
	table-layout: fixed;
	/* 固定表格布局，确保列宽度一致 */
}

.scrollable-table-wrapper {
	/* height: 630px; */
	height: calc(100vh - 440px);
	width: 95%;
	margin: 0 auto;
	overflow: auto;
	/* 使得内容可以横向滚动 */
	margin-left: 40px;
}

/* 定义滚动条整体样式 */
.scrollable-table-wrapper::-webkit-scrollbar {
	width: 10px;
	/* 设置滚动条的宽度 */
	height: 10px;
	/* 设置滚动条的高度 */
	background-color: #e9e8e8;
	/* 背景色 */
	border-radius: 10px;
	/* 圆角 */

}

/* 定义滚动条轨道样式 */
.scrollable-table-wrapper::-webkit-scrollbar-track {
	opacity: 0.5;
	box-shadow: inset 0 0 5px rgb(255, 255, 255);
	/* 轨道阴影 */
}

/* 鼠标滑过时滑块的背景色 */
.scrollable-table-wrapper::-webkit-scrollbar-thumb:hover {
	background: rgb(128, 126, 126);
}

/* 定义滚动条滑块样式 */
.scrollable-table-wrapper::-webkit-scrollbar-thumb {
	background: rgb(197, 197, 197);
	/* 设置滚动条滑块颜色 */
	border-radius: 10px;
	/* 圆角 */

}

.growth_table th {
	font-weight: bold;
	min-width: 200px;
	position: sticky;
	top: 0;
	/* z-index: 1; */
}

.growth_table td:first-child {
	position: sticky;
	left: 0;
	background: #fff;
}

.growth_table th:first-child {
	position: sticky;
	left: 0;
	z-index: 1;
}
</style>